import { CountrySettingOptions } from 'src/types/CountrySettings';

// SKU's are plan identifiers within chargebee.
// The SKU's are grouped by USD - for example grouped by $3 USD:
// com.invoicesimple.web.monthly.3.usd = 2.99
// com.invoicesimple.web.monthly.3.aud = 3.99
// com.invoicesimple.web.monthly.3.cad = 3.49

// legacy subscribers are using the { price } key
// new subscribers      subscription.(monthly | annual)[0]
// abtest segment       subscription.(monthly | annual)[x]

const euroPrices = {
  subscription: {
    price: [250, 85], // com.invoicesimple.web.monthly.3.eur.1.coupon
    monthly: [250],
    annual: [2500],
    tierPrice: {
      monthly: {
        starter: 799,
        pro: 1799,
        premium: 2499,
        essentials: 799,
        plus: 1799,
        newPremium: 2499,
        premiumLegacy: 2499,
        paymentsTier: 0
      },
      annual: {
        starter: 7999,
        pro: 17999,
        premium: 24999,
        essentials: 7999,
        plus: 17999,
        newPremium: 24999,
        premiumLegacy: 24999,
        paymentsTier: 0
      }
    },
    currencyCode: 'EUR'
  }
};

const countrySettingOptions: CountrySettingOptions = {
  US: {
    subscription: {
      price: [299, 99], // com.invoicesimple.web.monthly.3.usd.1.coupon
      monthly: [299],
      annual: [2999],
      tierPrice: {
        monthly: {
          starter: 699,
          pro: 1499,
          premium: 2199,
          paymentsTier: 0,
          lowEssentials: 699,
          essentials: 699,
          plus: 1499,
          newPremium: 2199,
          premiumLegacy: 2199
        },
        annual: {
          starter: 6999,
          pro: 14999,
          premium: 21999,
          paymentsTier: 0,
          lowEssentials: 6999,
          essentials: 6999,
          plus: 14999,
          newPremium: 21999,
          premiumLegacy: 21999
        }
      },
      currencyCode: 'USD'
    }
  },
  AU: {
    subscription: {
      price: [399, 135], // com.invoicesimple.web.monthly.3.aud.1.coupon
      monthly: [399],
      annual: [3999],
      tierPrice: {
        monthly: {
          starter: 999,
          pro: 2299,
          premium: 3499,
          essentials: 999,
          plus: 2299,
          newPremium: 3499,
          premiumLegacy: 3499,
          paymentsTier: 0
        },
        annual: {
          starter: 9999,
          pro: 22999,
          premium: 34999,
          essentials: 9999,
          plus: 22999,
          newPremium: 34999,
          premiumLegacy: 34999,
          paymentsTier: 0
        }
      },
      localizedTierPrice: {
        monthly: {
          essentials: 999,
          plus: 2299,
          premium: 3499,
          premiumLegacy: 3499
        },
        annual: {
          essentials: 9999,
          plus: 22999,
          premium: 34999,
          premiumLegacy: 34999
        }
      },
      currencyCode: 'AUD'
    }
  },
  CA: {
    subscription: {
      price: [349, 125], // com.invoicesimple.web.monthly.3.cad.1.coupon
      monthly: [349],
      annual: [3499],
      tierPrice: {
        monthly: {
          starter: 999,
          pro: 1999,
          premium: 2999,
          essentials: 999,
          plus: 1999,
          newPremium: 2999,
          premiumLegacy: 2999,
          paymentsTier: 0
        },
        annual: {
          starter: 9999,
          pro: 19999,
          premium: 29999,
          essentials: 9999,
          plus: 19999,
          newPremium: 29999,
          premiumLegacy: 29999,
          paymentsTier: 0
        }
      },
      localizedTierPrice: {
        monthly: {
          essentials: 999,
          plus: 1999,
          premium: 2999,
          premiumLegacy: 2999
        },
        annual: {
          essentials: 9999,
          plus: 19999,
          premium: 29999,
          premiumLegacy: 29999
        }
      },
      currencyCode: 'CAD'
    }
  },
  GB: {
    subscription: {
      price: [199, 75], // com.invoicesimple.web.monthly.3.gbp.1.coupon
      monthly: [199],
      annual: [1999],
      tierPrice: {
        monthly: {
          starter: 699,
          pro: 1499,
          premium: 1999,
          essentials: 699,
          plus: 1499,
          newPremium: 1999,
          premiumLegacy: 1999,
          paymentsTier: 0
        },
        annual: {
          starter: 6999,
          pro: 14999,
          premium: 19999,
          essentials: 6999,
          plus: 14999,
          newPremium: 19999,
          premiumLegacy: 19999,
          paymentsTier: 0
        }
      },
      localizedTierPrice: {
        monthly: {
          essentials: 699,
          plus: 1499,
          premium: 1999,
          premiumLegacy: 1999
        },
        annual: {
          essentials: 6999,
          plus: 14999,
          premium: 19999,
          premiumLegacy: 19999
        }
      },
      currencyCode: 'GBP'
    }
  },
  IN: {
    subscription: {
      price: [],
      monthly: [],
      annual: [],
      tierPrice: {
        monthly: {
          starter: 69900,
          pro: 149900,
          premium: 229900,
          essentials: 69900,
          plus: 149900,
          newPremium: 229900,
          premiumLegacy: 229900,
          paymentsTier: 0
        },
        annual: {
          starter: 690000,
          pro: 1499000,
          premium: 2299000,
          essentials: 690000,
          plus: 1490000,
          newPremium: 2299000,
          premiumLegacy: 2299000,
          paymentsTier: 0
        }
      },
      localizedTierPrice: {
        monthly: {
          essentials: 69900,
          plus: 149900,
          premium: 229900,
          premiumLegacy: 229900
        },
        annual: {
          essentials: 690000,
          plus: 1490000,
          premium: 2299000,
          premiumLegacy: 2299000
        }
      },
      currencyCode: 'INR'
    }
  },
  ZA: {
    subscription: {
      price: [4349, 1449], // com.invoicesimple.web.monthly.3.zar.1.coupon
      monthly: [4349],
      annual: [43499],
      tierPrice: {
        monthly: {
          starter: 14999,
          pro: 29999,
          premium: 49999,
          essentials: 14999,
          plus: 29999,
          newPremium: 49999,
          premiumLegacy: 49999,
          paymentsTier: 0
        },
        annual: {
          starter: 149999,
          pro: 299999,
          premium: 499999,
          essentials: 149999,
          plus: 299999,
          newPremium: 499999,
          premiumLegacy: 499999,
          paymentsTier: 0
        }
      },
      currencyCode: 'ZAR'
    }
  },
  NZ: {
    subscription: {
      price: [429, 145], // com.invoicesimple.web.monthly.3.nzd.1.coupon
      monthly: [429],
      annual: [4299],
      tierPrice: {
        monthly: {
          starter: 1299,
          pro: 2999,
          premium: 3999,
          essentials: 1299,
          plus: 2999,
          newPremium: 3999,
          premiumLegacy: 3999,
          paymentsTier: 0
        },
        annual: {
          starter: 12999,
          pro: 29999,
          premium: 39999,
          essentials: 12999,
          plus: 29999,
          newPremium: 39999,
          premiumLegacy: 39999,
          paymentsTier: 0
        }
      },
      currencyCode: 'NZD'
    }
  },
  NG: {
    subscription: {
      price: [122499, 40849], // com.invoicesimple.web.monthly.3.ngn.1.coupon
      monthly: [122499],
      annual: [1224999],
      tierPrice: {
        monthly: {
          starter: 990000,
          pro: 2490000,
          premium: 3490000,
          essentials: 990000,
          plus: 2490000,
          newPremium: 3490000,
          premiumLegacy: 3490000,
          paymentsTier: 0
        },
        annual: {
          starter: 9990000,
          pro: 24990000,
          premium: 34990000,
          essentials: 9990000,
          plus: 24990000,
          newPremium: 34990000,
          premiumLegacy: 34990000,
          paymentsTier: 0
        }
      },
      currencyCode: 'NGN'
    }
  },
  MY: {
    subscription: {
      price: [1249, 415], // com.invoicesimple.web.monthly.3.myr.1.coupon
      monthly: [1249],
      annual: [12499],
      tierPrice: {
        monthly: {
          starter: 2999,
          pro: 6999,
          premium: 9999,
          essentials: 2999,
          plus: 6999,
          newPremium: 9999,
          premiumLegacy: 9999,
          paymentsTier: 0
        },
        annual: {
          starter: 29999,
          pro: 69999,
          premium: 99999,
          essentials: 29999,
          plus: 69999,
          newPremium: 99999,
          premiumLegacy: 99999,
          paymentsTier: 0
        }
      },
      currencyCode: 'MYR'
    }
  },
  FR: { ...euroPrices },
  ES: { ...euroPrices }
};

export default countrySettingOptions;
